import React, { memo, useRef } from 'react';
import { useDrop } from 'react-dnd';

const BoxItem = memo(({ id, onMoveItem, onDropItem, children }) => {
  const ref = useRef(null);

  const [{ isOver }, connectDrop] = useDrop({
    accept: 'UMO',
    hover: (item) => {
      if (item.id !== id) {
        onMoveItem(item.id, id);
      }
    },
    drop: item => onDropItem(item),
    // collect: monitor => ({ isOver: !!monitor.isOver }),
  });

  connectDrop(ref);

  return (
    <div ref={ref}>{children}</div>
  );
});

export default BoxItem;



// WEBPACK FOOTER //
// ./src/js/components/UMOGallerySortView/BoxItem.jsx